import { render } from "./PanelLoader.vue?vue&type=template&id=674d7e5c&scoped=true"
import script from "./PanelLoader.vue?vue&type=script&lang=js"
export * from "./PanelLoader.vue?vue&type=script&lang=js"

import "./PanelLoader.vue?vue&type=style&index=0&id=674d7e5c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-674d7e5c"

export default script